import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=2c01493c&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=js&"
export * from "./PromoCard.vue?vue&type=script&lang=js&"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=2c01493c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01493c",
  null
  
)

export default component.exports